const units = {
  imperial: 'imperial',
  metric: 'metric',
};

export default units;
